import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useGrade } from "../gradingModel/hooks";
import { toast as toastFn } from "react-toastify";
import { useIRGrade } from "./hooks";
import {
  getAssessmentById,
  getLessonPlan,
} from "../../store/course/courseBaseApi";
import { useParams } from "react-router-dom";
import Button from "../../components/Button";
import { generateUUID } from "../../utils";
import { useDispatch } from "react-redux";
import { gradeActions } from "../../store/gradingModel/gradingModelSlice";

export const DiagnosticT1 = ({
  courseList,
  diagnosticT1,
  setDiagnosticT1,
  handleSubmit,
  isMapped,
  setIsMapped,
  diagnosticT2,
  setDiagnosticT2,
  nextLevelAssessments,
  setNextLevelAssessments,
}) => {
  const dispatch = useDispatch();
  const { loadGrades, gradeList, gradingModelList } = useGrade();
  const { courseMappingListV2 } = useIRGrade();
  const [lessonPlanData, setLessonPlanData] = useState();
  const [assessmentData, setAssessmentData] = useState();
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [assessmentId, setAssessmentId] = useState("");
  const [gradingModelId, setGradingModelId] = useState();
  const [gradingModel, setGradingModel] = useState();
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [assessmentName, setAssessmentName] = useState("");
  const { id } = useParams();

  useEffect(() => {
    loadGrades({ pageSize: 50 });
  }, []);

  useEffect(() => {
    if (gradeList?.data) {
      const filteredData = gradeList.data.filter(
        (item) => item.category === "DIAGNOSTIC",
      );
      dispatch(gradeActions.setGradingModelList(filteredData || []));
      setHasMore(!gradeList?.last);
    }
  }, [gradeList]);

  useEffect(() => {
    if (hasMore) {
      setPage((prevPage) => prevPage + 1);
    }
  }, [gradingModelList, hasMore]);

  useEffect(() => {
    if (gradingModelId && !id) {
      const gradingModel = gradingModelList?.find(
        (grade) => grade?.id === gradingModelId,
      );
      setGradingModel(gradingModel);
      const initialAssessments = gradingModel.details.map((item, index) => ({
        id: generateUUID(),
        gradeName: item.gradeName,
        courseId: diagnosticT1?.nextLevelAssessments[index]?.courseId || "",
        irLevel: diagnosticT1?.nextLevelAssessments[index]?.irLevel || "",
        gradingModel: gradingModel.id,
        maxPercentage: item.max,
        minPercentage: item.min,
      }));
      setNextLevelAssessments(initialAssessments);
    } else {
      const gradingModel = gradingModelList?.find(
        (grade) => grade?.id === diagnosticT1?.gradingModel,
      );
      setGradingModel(gradingModel);
      setNextLevelAssessments(diagnosticT1?.nextLevelAssessments);
    }
  }, [gradingModelId, diagnosticT1, gradingModelList]);

  const fetchLessonPlan = async (_id) => {
    try {
      let { data } = await getLessonPlan({ id: _id });
      setLessonPlanData(data?.lessonPlan);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAssessment = async (_id) => {
    try {
      let { data } = await getAssessmentById({ id: _id });
      setAssessmentData(data);
    } catch {
      console.error(error);
    }
  };

  useEffect(() => {
    if (selectedCourseId) {
      fetchLessonPlan(selectedCourseId);
    }
  }, [selectedCourseId]);

  useEffect(() => {
    if (lessonPlanData && lessonPlanData?.sections?.length > 0) {
      const section = lessonPlanData.sections[0];
      if (section?.chapters?.length > 0) {
        const chapter = section.chapters[0];
        if (chapter?.assessments?.length > 0) {
          const assessmentId = chapter.assessments[0].id;
          setAssessmentId(assessmentId);
        } else {
          toastFn.error("No assessments found");
          setAssessmentId("");
          setAssessmentName("");
          setAssessmentData("");
        }
      }
    }
  }, [lessonPlanData]);

  useEffect(() => {
    if (assessmentId) {
      fetchAssessment(assessmentId);
    }
  }, [assessmentId]);

  useEffect(() => {
    if (assessmentData) {
      setAssessmentName(assessmentData?.name);
      setDiagnosticT1((prevState) => ({
        ...prevState,
      }));
    }
  }, [assessmentData]);

  useEffect(() => {
    if (diagnosticT1) {
      setSelectedCourseId(diagnosticT1?.courseId);
      // setIsMapped(true);
    }
  }, [diagnosticT1]);

  const handleChange = (e, id) => {
    const { name, value } = e.target;

    if (name === "courseId") {
      setSelectedCourseId(value);
      setDiagnosticT1((prevState) => ({
        ...prevState,
        courseId: value,
      }));
      return;
    }
    if (name === "gradingModel") {
      setGradingModelId(value);
      setDiagnosticT1((prevState) => ({
        ...prevState,
        gradingModel: value,
      }));
      return;
    }
    // setNextLevelAssessments((prevState) => {
    //     const updatedAssessments = [...prevState];
    //     updatedAssessments[index] = {
    //         ...updatedAssessments[index],
    //         [name === 'irCourseId' ? 'courseId' : 'irLevel']: value,
    //     };
    //     return updatedAssessments;
    // });
    setNextLevelAssessments((prevState) => {
      const updatedAssessments = prevState.map((item) =>
        item.id === id
          ? { ...item, [name === "irCourseId" ? "courseId" : "irLevel"]: value }
          : item,
      );

      setDiagnosticT2((prevT2) =>
        prevT2.map((t2Item) =>
          t2Item.id === id
            ? {
                ...t2Item,
                [name === "irCourseId" ? "courseId" : "irLevel"]: value,
                gradingModel: "", // Reset `gradingModel`
                nextLevelAssessments: [],
              }
            : t2Item,
        ),
      );
      return updatedAssessments; // Ensure a new array is returned
    });
  };

  const validateMapping = () => {
    if (
      !diagnosticT1?.courseId ||
      !diagnosticT1?.gradingModel ||
      !gradingModel?.details
    ) {
      return false; // Disable if the main fields are missing
    }

    // Ensure all assessments have required fields populated
    for (const assessment of nextLevelAssessments) {
      if (
        !assessment.gradeName || // Grade Name must exist
        (assessment.gradeName <= "B" && !assessment.courseId) || // Diagnostic Tests require courseId
        (assessment.gradeName > "B" && !assessment.irLevel) // IR Levels require irLevel
      ) {
        return false;
      }
    }

    return true;
  };

  return (
    <Box>
      <Typography
        align="center"
        variant="h1"
        sx={{
          margin: 1,
          fontWeight: "700",
          lineHeight: "1.5",
          fontSize: "1rem",
          color: !isMapped ? "#fff" : "primary.blue",
          background: !isMapped ? "#403e75" : "#00000014",
          padding: 1,
          borderRadius: 1,
        }}
      >
        Diagnostic Test - 1
      </Typography>
      <Grid sx={styles.gridContainer} container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <InputLabel style={styles.inputLabel}>Diagnostic Test 1</InputLabel>
          <FormControl fullWidth>
            <Select
              name="courseId"
              value={diagnosticT1?.courseId || ""}
              placeholder="Select Diagnostic Test"
              onChange={(e) => handleChange(e)}
              sx={{ height: "47px" }}
              disabled={isMapped}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {courseList?.map((item, id) => {
                return (
                  <MenuItem key={id} value={item.id}>
                    {item?.courseName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        {diagnosticT1?.courseId && assessmentData && (
          <>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <InputLabel style={styles.inputLabel}>Assessment </InputLabel>
              <TextField
                name="assessmentName"
                fullWidth
                value={assessmentName || ""}
                disabled
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <InputLabel style={styles.inputLabel}>Grading Model</InputLabel>
              <FormControl fullWidth>
                <Select
                  name="gradingModel"
                  value={diagnosticT1?.gradingModel || ""}
                  placeholder="Select Grading Model"
                  onChange={(e) => handleChange(e)}
                  sx={{ height: "47px" }}
                  // disabled={isMapped}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {gradingModelList?.map((item, id) => {
                    return (
                      <MenuItem key={id} value={item.id}>
                        {item.gradingModelName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
          </>
        )}
      </Grid>
      <Grid sx={styles.gridContainer} container spacing={2} alignItems="center">
        {gradingModel?.details &&
          nextLevelAssessments &&
          nextLevelAssessments?.map((item, index) => {
            const isDiagnostic = item.gradeName <= "B";
            const isPassGrade = item.gradeName === "B";
            const maxMark = item?.maxPercentage;
            const minMark = item?.minPercentage;
            return (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel style={styles.inputLabel}>
                    {isPassGrade ? "(Pass Grade)" : "Grade"}
                  </InputLabel>
                  <TextField fullWidth value={item?.gradeName || ""} disabled />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <InputLabel style={styles.inputLabel}>
                    {isDiagnostic ? "Diagnostic Test 2" : "IR Level"}
                  </InputLabel>
                  <FormControl fullWidth>
                    <Select
                      name={isDiagnostic ? "irCourseId" : "irLevel"}
                      value={
                        isDiagnostic
                          ? item?.courseId || ""
                          : item?.irLevel || ""
                      }
                      placeholder={
                        isDiagnostic
                          ? "Select Diagnostic Test"
                          : "Select IR Level"
                      }
                      onChange={(e) => handleChange(e, item?.id)}
                      sx={{ height: "47px" }}
                      disabled={isMapped}
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      {isDiagnostic
                        ? courseList?.map((course) => (
                            <MenuItem key={course.id} value={course.id}>
                              {course.courseName}
                            </MenuItem>
                          ))
                        : courseMappingListV2?.map((levelItem, idx) => (
                            <MenuItem
                              key={levelItem?.levelId}
                              value={levelItem.irLevel}
                            >
                              {levelItem.irLevel}
                            </MenuItem>
                          ))}
                    </Select>
                  </FormControl>
                </Grid>
              </React.Fragment>
            );
          })}
      </Grid>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
        <Button
          sx={{ p: 1, fontSize: "14px" }}
          variant="contained"
          disabled={!validateMapping() || isMapped}
          onClick={handleSubmit}
          color="primary"
          placeholder={isMapped ? "Mapped" : "Map"}
        />
        {/* {isMapped && */}
        <Button
          sx={{ p: 1, fontSize: "14px" }}
          variant="contained"
          onClick={() => setIsMapped(false)}
          color="primary"
          placeholder={"Edit"}
        />
        {/* } */}
      </Box>
    </Box>
  );
};

const styles = {
  label: {
    color: "var(--mui-palette-common-black)",
    fontWeight: "bold",
  },
  inputLabel: {
    color: "var(--mui-palette-primary-darkGrey)",
    marginBottom: "5px",
    fontWeight: "600",
    fontSize: "1em",
  },
  gridContainer: {
    mt: 1,
    display: "flex",
  },
  suggestionBox: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "10px",
  },
  suggestionItem: {
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "2px",
    cursor: "pointer",
    boxShadow: "0 4px 8px var(--mui-palette-secondary-boxShadow1)",
    backgroundColor: "var(--mui-palette-gray-lightGrey300)",
  },
  uploadBtn: {
    width: "30px",
    height: "30px",
    boxShadow: "none",
    border: "none",
    backgroundColor: "transparent",
    padding: 0,
    borderRadius: "0",
    minWidth: "30px",
  },
  hiddenInput: {
    display: "none",
  },
  actionBtnItem: {
    marginLeft: "5px",
    marginRight: "5px",
    cursor: "pointer",
    display: "flex",
    gap: "20px",
    alignItems: "center",
  },
  row: {
    padding: "5px 16px",
  },
};
